import {onMounted, onUnmounted, watch} from 'vue';
import {IReCaptchaComposition, useReCaptcha as _useReCaptcha} from 'vue-recaptcha-v3';

export const useReCaptcha = () => {
    const {executeRecaptcha, isLoaded, instance, recaptchaLoaded} = _useReCaptcha() as IReCaptchaComposition;

    const showBadge = () => instance.value?.showBadge();

    watch(isLoaded, () => {
        if (isLoaded) {
            showBadge();
        }
    });

    onMounted(() => {
        showBadge();
    });

    onUnmounted(() => {
        instance.value?.hideBadge();
    });

    return {
        isLoaded,
        executeRecaptcha,
        recaptchaLoaded,
    };
};
